// src/pages/SolicitudesHub.jsx
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import { MODULES, ACTIONS } from "../utils/permissions";
import { Can } from "../components/PermissionGuard";

export default function SolicitudesHub() {
  const navigate = useNavigate();
  const { hasModuleAccess } = usePermissions();

  // Check if user has any access to solicitudes
  if (!hasModuleAccess(MODULES.SOLICITUDES)) {
    return (
      <div className="container">
        <div className="header">
          <span className="badge">FIRMAS CEJM</span>
        </div>

        <div className="card" style={{ 
          textAlign: 'center', 
          padding: '48px 24px',
          background: '#fef2f2',
          border: '2px solid #fecaca'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
          <h2 style={{ color: '#dc2626', marginBottom: '8px' }}>Sin acceso a solicitudes</h2>
          <p style={{ color: '#7f1d1d', margin: 0 }}>
            No tienes permisos para acceder al sistema de solicitudes de partes de trabajo.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header">
        <span className="badge">FIRMAS CEJM</span>
      </div>

      <h1 className="title">🔧 Gestión de Partes de Trabajo</h1>

      <div className="card grid" style={{ gap: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p className="meta" style={{ fontSize: '16px', lineHeight: 1.5 }}>
            Desde aquí puedes crear nuevas solicitudes de partes de trabajo o revisar las solicitudes existentes.
          </p>
        </div>

        {/* Opción 1: Crear Nueva Solicitud */}
        <Can module={MODULES.SOLICITUDES} action={ACTIONS.CREATE}>
          <div 
            className="card"
            style={{ 
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: '2px solid #16a34a',
              background: '#ffffff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}
            onClick={() => navigate('/solicitar-parte')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(22, 163, 74, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
            }}
          >
            <div style={{ textAlign: 'center', padding: '28px 20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📝</div>
              <h2 style={{ 
                margin: '0 0 12px 0', 
                color: '#166534', 
                fontSize: '22px',
                fontWeight: 700
              }}>
                Crear Nueva Solicitud
              </h2>
              <p style={{ 
                margin: '0 0 16px 0', 
                color: '#475569', 
                fontSize: '15px',
                lineHeight: 1.5
              }}>
                Solicita un nuevo parte de trabajo completando el formulario con todos los detalles necesarios.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginTop: '16px' }}>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>
                  ✅ Formulario completo
                </span>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>
                  👥 Selección de operarios
                </span>
                <span className="badge" style={{ background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0', fontSize: '12px' }}>
                  📧 Envío automático
                </span>
              </div>
            </div>
          </div>
        </Can>

        {/* Opción 2: Ver Solicitudes Existentes */}
        <Can module={MODULES.SOLICITUDES} action={ACTIONS.READ}>
          <div 
            className="card"
            style={{ 
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              border: '2px solid #3b82f6',
              background: '#ffffff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}
            onClick={() => navigate('/historial-solicitudes')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
            }}
          >
            <div style={{ textAlign: 'center', padding: '28px 20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
              <h2 style={{ 
                margin: '0 0 12px 0', 
                color: '#1e40af', 
                fontSize: '22px',
                fontWeight: 700
              }}>
                Ver Solicitudes Existentes
              </h2>
              <p style={{ 
                margin: '0 0 16px 0', 
                color: '#475569', 
                fontSize: '15px',
                lineHeight: 1.5
              }}>
                Revisa el historial de solicitudes enviadas y crea partes de trabajo cuando sea necesario.
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginTop: '16px' }}>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>
                  📊 Historial completo
                </span>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>
                  🔧 Crear partes
                </span>
                <span className="badge" style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe', fontSize: '12px' }}>
                  📈 Estados de solicitudes
                </span>
              </div>
            </div>
          </div>
        </Can>

        {/* Información adicional */}
        <div style={{ 
          background: '#f8fafc', 
          padding: '24px', 
          borderRadius: '12px', 
          border: '1px solid #e2e8f0',
          textAlign: 'center',
          marginTop: '8px'
        }}>
          <h3 style={{ margin: '0 0 16px 0', color: '#0f172a', fontSize: '16px', fontWeight: 600 }}>
            💡 ¿Cómo funciona?
          </h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '16px',
          }}>
            <div style={{ padding: '16px', background: '#ffffff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#1e293b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, margin: '0 auto 10px' }}>1</div>
              <p style={{ margin: 0, fontSize: '13px', color: '#475569' }}>
                <strong style={{ color: '#0f172a' }}>Crear Solicitud:</strong> Completa el formulario con los detalles del trabajo
              </p>
            </div>
            <div style={{ padding: '16px', background: '#ffffff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#1e293b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, margin: '0 auto 10px' }}>2</div>
              <p style={{ margin: 0, fontSize: '13px', color: '#475569' }}>
                <strong style={{ color: '#0f172a' }}>Envío Automático:</strong> La solicitud se envía automáticamente por email
              </p>
            </div>
            <div style={{ padding: '16px', background: '#ffffff', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: '#1e293b', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, margin: '0 auto 10px' }}>3</div>
              <p style={{ margin: 0, fontSize: '13px', color: '#475569' }}>
                <strong style={{ color: '#0f172a' }}>Crear Parte:</strong> Desde el historial se pueden crear partes con datos pre-rellenados
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}